//送信エリア
import React, { useState }  from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import { withCookies } from 'react-cookie';

const styles = () => ({
    root: {
        display: 'flex',
        justifyContent: 'left   ',
        alignItems: 'start',
        flexDirection: 'column',
        margin: '30px 0px 0px 0px',
    }
});

const RequestCheckBox = withCookies((props) => {
    const { cookies, classes, chatRequestFlg, setChatRequestFlg, setDisplayChatName, setSelectedKubunId } = props;

    //宛名連携機能を利用する場合
    const availableAddress = cookies.get('AVAILABLE_ADDRESS') === 'TRUE' ? true : false;

    function handleChange(event){
        setChatRequestFlg(event.target.checked);
        //宛名連携機能を利用する場合は検索したカテゴリを利用する
        if(!availableAddress){
            setDisplayChatName('---選択してください---');
            setSelectedKubunId('');
        }
    }
    console.log(chatRequestFlg);

    return (
        <React.Fragment>
            <Grid container direction="column" >
                <div style={{ height: '100%' }}>
                    <div className={classes.root}>
                        <FormControlLabel
                            control={<Checkbox checked={chatRequestFlg} onChange={(event) => handleChange(event)}/>}
                            label={<Typography variant="body1">依頼メッセージを送信する</Typography>}
                        />
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
});

export default withStyles(styles)(RequestCheckBox);